import InputRadio from "./Input.Radio";

export default InputRadio;